'use client'

import { useRouter } from 'next/navigation'
import TagFilter from './tag-filter'
import { TagDrawer } from './tag-drawer'
import { useResponsive } from '@dustin-web/microsite-components/src/hooks'

type Props = {
  href: string
  tags: { label: string; value: string }[]
  selectedCategory: string
  selectedTag: string
}

const Tags = ({ href, tags, selectedCategory, selectedTag }: Props) => {
  const router = useRouter()
  const { isSmallScreen } = useResponsive()

  const handleFilterClick = (value: string) => {
    router?.push(
      selectedCategory
        ? `${href}?category=${encodeURIComponent(selectedCategory)}&tag=${value}`
        : `${href}?tag=${value}`
    )
  }

  const clearTag = () => {
    router?.push(
      selectedCategory ? `${href}?category=${encodeURIComponent(selectedCategory)}` : `${href}`
    )
  }

  return (
    <>
      {isSmallScreen ? (
        <TagDrawer
          onTagClick={handleFilterClick}
          clearTag={clearTag}
          tags={tags}
          selectedTag={selectedTag}
        />
      ) : (
        <div className="col-3">
          <TagFilter
            tags={tags}
            onTagClick={handleFilterClick}
            clearTag={clearTag}
            selectedTag={selectedTag}
          />
        </div>
      )}
    </>
  )
}

export default Tags
